<template>
  <div class="relative">
    <div
      class="font-inter font-normal text-text-color text-sm px-3 py-2 rounded-md"
      :style="getMediumStyle(notification.webpush)"
      @mouseover="toggleToolTip"
      @mouseleave="toggleToolTip"
    >
      {{
        (notification.webpush && notification.webpush.status) || GENERAL_CONSTANTS.NOT_APPLICABLE
      }}
    </div>

    <UiTooltip
      v-if="showTooltip && notification.webpush"
      :title="title"
      :description="description"
      :position-class="positionClass"
    />
  </div>
</template>

<script>
import UiTooltip from '@src/components/UiSelectTooltip.vue'
import { getMediumStyle } from '@src/utils/filters/announcements/index.js'
import DATE_TIME_CONSTANT from '@src/constants/date-time-constants.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants'

export default {
  components: {
    UiTooltip,
  },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    tooltipPosition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DATE_TIME_CONSTANT,
      GENERAL_CONSTANTS,
      showTooltip: false,
    }
  },
  computed: {
    title() {
      if (this.notification?.webpush?.status === 'sent') {
        return 'successfully sent'
      } else if (this.notification?.webpush?.failed_reason) {
        return this.notification.webpush.failed_reason
      }
      return 'reason not found'
    },
    description() {
      if (this.notification?.webpush?.last_attempted_at) {
        return this.$filters.formattedDate(
          this.notification.webpush.last_attempted_at,
          DATE_TIME_CONSTANT.DATE_TIME_12,
        )
      }
      return 'time not found'
    },
    positionClass() {
      return this.tooltipPosition
        ? 'bottom-12 before:-bottom-2 before:right-4 right-0'
        : 'top-12 before:-top-2 before:right-4 right-0'
    },
  },
  methods: {
    getMediumStyle,
    toggleToolTip() {
      this.showTooltip = !this.showTooltip
    },
  },
}
</script>
